import WematchEventAgain from "../../../../src/events/2022/06/wematchAgain/main";
import * as React from 'react';
export default {
  WematchEventAgain,
  React
};